import{m as s}from"./chunk-HBP5N4FR.js";s();var r=class{constructor(t,e,i,n,d){this.sender=t,this.receiver=e,this.functionName=i,this.inputParameters=n,this.outputParameters=d}};export{r as a};
//# sourceMappingURL=chunk-V4ATVQP5.js.map
